<template>
  <div class="scratchcard" :style="`width:${cardWidth}px; height:${cardHeight}px`">
    <div style="display: none">
      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
           viewBox="0 0 113.5 113.5" style="enable-background:new 0 0 113.5 113.5;" xml:space="preserve">
        <g>
	<path class="st0" d="M56.7,28.1C45.9,28.1,37,36.9,37,47.8s8.9,19.7,19.7,19.7s19.7-8.9,19.7-19.7S67.6,28.1,56.7,28.1z M56.7,63.2
		c-8.5,0-15.3-6.9-15.3-15.3s6.9-15.3,15.3-15.3S72,39.5,72,47.9S65.2,63.2,56.7,63.2z"/>
          <path :style="{fill: imageBg}" d="M66.3,42.1L61,41.4l-2.3-4.7c-0.4-0.7-1.1-1.2-2-1.2c-0.8,0-1.6,0.5-2,1.2l-2.3,4.7l-5.2,0.8
		c-0.8,0.1-1.5,0.7-1.8,1.5s0,1.7,0.6,2.2l3.8,3.7l-0.9,5.2c-0.1,0.8,0.2,1.7,0.9,2.1c0.7,0.5,1.6,0.6,2.3,0.2l4.7-2.5l4.7,2.5
		c0.3,0.2,0.7,0.3,1,0.3c0.5,0,0.9-0.1,1.3-0.4c0.7-0.5,1-1.3,0.9-2.1l-0.9-5.2l3.8-3.7c0.6-0.6,0.8-1.5,0.6-2.2
		C67.8,42.8,67.1,42.2,66.3,42.1z M59.8,47.2c-0.5,0.5-0.8,1.2-0.6,1.9l0.3,2l-1.8-0.9c-0.3-0.2-0.7-0.3-1-0.3s-0.7,0.1-1,0.3
		l-1.8,0.9l0.3-2c0.1-0.7-0.1-1.4-0.6-1.9l-1.4-1.4l2-0.3c0.7-0.1,1.3-0.6,1.7-1.2l0.9-1.8l0.9,1.8c0.3,0.6,0.9,1.1,1.7,1.2l2,0.3
		L59.8,47.2z"/>
          <path :style="{fill: imageBg}" d="M56.7,0.2C25.5,0.2,0.2,25.5,0.2,56.7s25.3,56.5,56.5,56.5s56.5-25.3,56.5-56.5S87.9,0.2,56.7,0.2z M51.1,92.5
		c-0.2,0.9-1,1.5-1.8,1.6c-0.1,0-0.2,0-0.3,0c-0.8,0-1.5-0.4-1.9-1.1l-3-5.3l-5.3,3c-0.8,0.4-1.7,0.4-2.4-0.2
		c-0.7-0.5-1-1.5-0.8-2.3L39,75.4c0.4,0.3,0.8,0.6,1.3,0.9c1.5,0.9,3.2,1.3,5.1,1.3c1.1,0,2-0.1,2.8-0.2c0.2,0,0.4,0,0.6-0.1
		c0.1,0.1,0.3,0.2,0.4,0.3c1.1,0.9,2.9,2.2,5.1,2.8L51.1,92.5z M77.1,90.7c-0.7,0.5-1.7,0.6-2.4,0.2l-5.3-3l-3,5.3
		c-0.4,0.7-1.1,1.1-1.9,1.1c-0.1,0-0.2,0-0.3,0c-0.9-0.1-1.6-0.7-1.8-1.6l-3.3-12.1c2.3-0.6,4-1.9,5.1-2.8c0.1-0.1,0.3-0.2,0.4-0.3
		c0.2,0,0.4,0,0.6,0.1c0.8,0.1,1.8,0.2,2.8,0.2c1.9,0,3.6-0.4,5.1-1.3c0.5-0.3,0.9-0.6,1.3-0.9l3.5,12.9
		C78.2,89.2,77.8,90.1,77.1,90.7z M83,52.7c-0.5,0.7-1.1,1.4-1.2,1.9s0,1.4,0.1,2.3c0.2,1.6,0.5,3.5-0.5,5.2s-2.8,2.5-4.3,3.1
		c-0.8,0.3-1.7,0.7-2,1.1c-0.4,0.4-0.7,1.2-1.1,2c-0.6,1.5-1.4,3.3-3.1,4.3s-3.5,0.7-5.2,0.5c-0.9-0.1-1.8-0.2-2.3-0.1
		s-1.2,0.7-1.9,1.2c-1.3,1-2.9,2.2-4.9,2.2s-3.6-1.2-4.9-2.2c-0.7-0.5-1.4-1.1-1.9-1.2s-1.4,0-2.3,0.1c-1.6,0.2-3.5,0.5-5.2-0.5
		s-2.5-2.8-3.1-4.3c-0.3-0.8-0.7-1.7-1.1-2s-1.2-0.7-2-1.1c-1.5-0.6-3.3-1.4-4.3-3.1c-1-1.7-0.7-3.5-0.5-5.2
		c0.1-0.9,0.2-1.8,0.1-2.3s-0.7-1.2-1.2-1.9c-1-1.3-2.2-2.9-2.2-4.9s1.2-3.6,2.2-4.9c0.5-0.7,1.1-1.4,1.2-1.9s0-1.4-0.1-2.3
		c-0.2-1.6-0.5-3.5,0.5-5.2s2.8-2.5,4.3-3.1c0.8-0.3,1.7-0.7,2-1.1c0.4-0.4,0.7-1.2,1.1-2c0.6-1.5,1.4-3.3,3.1-4.3
		c1.7-1,3.5-0.7,5.2-0.5c0.9,0.1,1.8,0.2,2.3,0.1s1.2-0.7,1.9-1.2c1.3-1,2.9-2.2,4.9-2.2s3.6,1.2,4.9,2.2c0.7,0.5,1.4,1.1,1.9,1.2
		s1.4,0,2.3-0.1c1.6-0.2,3.5-0.5,5.2,0.5s2.5,2.8,3.1,4.3c0.3,0.8,0.7,1.7,1.1,2s1.2,0.7,2,1.1c1.5,0.6,3.3,1.4,4.3,3.1
		s0.7,3.5,0.5,5.2c-0.1,0.9-0.2,1.8-0.1,2.3s0.7,1.2,1.2,1.9c1,1.3,2.2,2.9,2.2,4.9S84,51.4,83,52.7z"/>
</g>
</svg>
    </div>
    <canvas @mousedown="handleMouseDown" @mousemove="handleMouseMove" @mouseup="handleMouseUp"
            @touchstart="handleMouseDown" @touchmove="handleMouseMove" @touchend="handleMouseUp"
            ref="canvas" class="scratchcard-overlay radius-30"></canvas>
    <div v-if="overlayLoaded" class="scratchcard-content bg-light radius-30 align-ver space-around">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  import medalLight from '@/assets/medal-white.svg';
  function getFilledPercent(ctx, width, height, stride) {
    if (!stride || stride < 1) stride = 1;
    const pixels = ctx.getImageData(0, 0, width, height);
    const total = pixels.data.length / stride;
    let count = 0;
    for (let i = 0; i < pixels.data.length; i += stride) {
      if (parseInt(pixels.data[i], 10) === 0) count++;
    }
    return Math.round(count / total * 100);
  }
  function getMouse(e, canvas) {
    const { left, top } = canvas.getBoundingClientRect();
    const touch = e.touches && e.touches[0];
    if (touch) {
      return { x: touch.clientX - left, y: touch.clientY - top };
    } else {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
      return { x: e.pageX - left - scrollLeft, y: e.pageY - top - scrollTop };
    }
  }
  function distanceBetween(point1, point2) {
    return Math.sqrt(
      Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2),
    );
  }
  function angleBetween(point1, point2) {
    return Math.atan2(point2.x - point1.x, point2.y - point1.y);
  }

  export default {
    name: 'scratch-card',
    props: {
      imageBg: String,
      imageUrl: String,
      imageDarkBg: String,
      brushUrl: String,
      cardWidth: Number,
      cardHeight: Number,
      finishPercent: Number,
      forceReveal: Boolean,
      onComplete: Function,
      cardRange: String
    },
    data() {
      return {
        overlayLoaded: false,
        isDrawing: false,
        isFinished: false,
        canvas: undefined,
        ctx: undefined,
        lastPoint: undefined,
        brush: new Image(),
        bgImg1: new Image(),
        bgImg2: new Image()
      };
    },
    methods: {
      initCanvas() {
        this.canvas = this.$refs.canvas;
        this.canvas.width = this.cardWidth;
        this.canvas.height = this.cardHeight;
        this.ctx = this.canvas.getContext('2d');
      },
      drawCard() {
        var self = this;
        self.ctx.fillStyle = self.imageBg;
        self.ctx.rect(0, 0, self.cardWidth, self.cardHeight);
        self.ctx.fill();
        this.bgImg1.src = this.imageUrl;
        //this.ctx.globalAlpha = 0.4;
        this.ctx.drawImage(this.bgImg1,0,0);
        //this.ctx.drawImage(this.bgImg1,this.cardWidth/2, this.cardHeight/2)
        this.overlayLoaded = true;
      },
      prepBrush() {
        if (this.brushUrl) {
          this.brush.crossOrigin = 'kikus';
          this.brush.src = this.brushUrl;
          this.ctx.drawImage(this.brush,0,0);
        }
      },
      scratchAt(x, y) {
    //    console.log(x,y);
        if (this.brushUrl) {
          this.ctx.drawImage(
            this.brush,
            x - this.brush.width / 2,
            y - this.brush.height / 2,
          );
        } else {
          this.ctx.beginPath();
          this.ctx.arc(x, y, 25, 0, 2 * Math.PI, false);
          this.ctx.fill();
        }
      },
      handleMouseDown(e) {
        this.isDrawing = true;
        this.lastPoint = getMouse(e, this.canvas);
      },
      handleMouseUp() {
        this.isDrawing = false;
      },
      handleMouseMove(e) {
        if (!this.isDrawing) return;
        e.preventDefault();
        const currentPoint = getMouse(e, this.canvas);
        const distance = distanceBetween(this.lastPoint, currentPoint);
        const angle = angleBetween(this.lastPoint, currentPoint);
        let x, y;
        for (let i = 0; i < distance; i++) {
          x = this.lastPoint.x + Math.sin(angle) * i;
          y = this.lastPoint.y + Math.cos(angle) * i;
          this.ctx.globalCompositeOperation = 'destination-out';
          this.scratchAt(x, y);
        }
        this.lastPoint = currentPoint;
        this.handlePercentage(
          getFilledPercent(this.ctx, this.cardWidth, this.cardHeight, 32),
        );
      },
      handlePercentage(filledInPixels = 0) {
       // console.log(filledInPixels);
        if (filledInPixels > this.finishPercent) this.reveal();
      },
      reveal() {
        if (!this.isFinished) {
          this.canvas.parentNode.removeChild(this.canvas);
          this.$emit("complete");
          if (this.onComplete) this.onComplete();
        }
        this.isFinished = true;
      },
    },
    watch: {
      forceReveal(val) {
        console.log("Forcely revealed")
        if (val) this.reveal();
      },
    },
    mounted() {
      this.initCanvas();
      this.drawCard();
      this.prepBrush();
      if (typeof this.onComplete !== 'undefined') {
        // eslint-disable-next-line
        console.warn('[vue-scratchcard] - `onComplete` call is deprecated in favor of `complete` event');
      }
    },
  };
</script>
<style scoped>
  .scratchcard {
    position: relative;
    display: block;
  }
  .scratchcard > * {
    position: absolute;
    width: 100%;
    height: 100%;
    display: block;
  }
  .scratchcard-content {
    display: flex;
  }
  .scratchcard-overlay {
    z-index: 2;
  }
</style>



// WEBPACK FOOTER //
// src/components/scratch-card.vue